<template>
<v-container fluid>

  <PanelBar></PanelBar>

  <template v-for="d in Object.keys(userDevice).filter(d=>userDevice[d].info)">
    <PanelDetail :pie="d" :data="userDevice[d]||{}" :online="userDeviceOnline[d]||{}" :deviceOnline="userDeviceOnline[d]||{}" @toast="val=>$emit('toast',val)" :key="d"></PanelDetail>
  </template>

</v-container>
</template>

<script>
import PanelDetail from '@/components/panel/PanelDetail'
import PanelBar from '@/components/utils/PanelBar'

export default {
  name: 'GlobalPanel',
  components: {
    PanelDetail,
    PanelBar
  },
  data() {
    return {
      userDevice: {},
      userDeviceOnline: {}
    }
  },
  mounted() {
    this.$db.ref(`pie`).on('value', snapshot => {
      this.userDevice = snapshot.val();
    });
    this.$db.ref(`pieOnline`).on('value', snapshot => {
      this.userDeviceOnline = snapshot.val();
    });
  },
  beforeDestory() {
    this.$db.ref(`pie`).off();
    this.$db.ref(`pieOnline`).off();
  }
}
</script>
